<template lang="html">
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell
        v-for="invitation in invitations" :key="invitation.id"
        @click="invitationDetail(invitation.id)"
      >
        <van-skeleton
          avatar
          avatar-shape="square"
          avatar-size="50"
          :row="3"
          :loading="skeletonLoading"
        >

          <van-row gutter="8">
            <van-col span="2">
              <img
                :src="invitation.sender.wechat_profile.headimgurl"
                style="width:100%;border-radius:50%"
              />
            </van-col>
            <van-col span="22">
              <van-row type="flex" justify="space-between" align="center">
                <van-col span="10">
                  <!-- <strong>{{SenderName}}</strong> -->
                  <strong>{{invitation.sender.wechat_profile.nickname}}</strong> 赠给你：
                </van-col>
                <van-col
                  span="14"
                  style="display:flex;justify-content:flex-end;"
                >
                  <!-- <van-tag plain type="danger">赠送</van-tag> -->
                </van-col>
              </van-row>
            </van-col>
          </van-row>

          <van-row>
            <van-col offset="2" span="22">
              <EpisodeCard
                :click-disabled="true"
                :compact="true"
                :showDescription="false"
                :showRating="false"
                :showPubtime="false"
                :episodeId="invitation.giftcard_objectid"
              />
            </van-col>
          </van-row>
        </van-skeleton>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import Vue from 'vue'
import { List } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Skeleton } from 'vant'
import { Tag } from 'vant'
import EpisodeCard from './episode-card.vue'
Vue.use(List)
Vue.use(Cell).use(CellGroup)
Vue.use(Skeleton)
Vue.use(Tag)
export default {
  name: 'gift-card-invitation-list',
  components: {
    EpisodeCard
  },
  data () {
    return {
      skeletonLoading: false,
      loading: false,
      finished: false,
      finishedText: '没有更多了',
      invitations: [],
      next: ''
    }
  },
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  watch: {
    slug (newVal, oldVal) {
      window.console.log("watch slug")
      window.console.log(newVal)
      window.console.log(oldVal)
      if (newVal && newVal != oldVal) {
        this.getInvitations()
      }
    }
  },
  methods: {
    loadData () {
      this.getInvitations()
    },
    getInvitations () {
      let that = this
      let params = { slug: that.slug }
      window.console.log("开始获得Invitation...")
      that.$api.invitation.list(params).then(res => {
        window.console.log("获得Invitation")
        window.console.log(res.data)
        that.next = res.data.next
        that.loading = false
        if (res.data.next == null) {
          that.finished = true
        }
        if (that.limit > 0) {
          that.invitations = res.data.results.slice(0, that.limit)
        } else {
          that.invitations = res.data.results
        }
        return
      })
    },
    loadMore () {
      window.console.log("loadMore...")
      let that = this
      if (that.next) {
        that.loading = true
        let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
        that.$api.normal.load(url).then(res => {
          that.invitations = that.invitations.concat(res.data.results)
          that.next = res.data.next
          that.loading = false
          if (that.next == null) {
            that.finished = true
          }
        })
      } else {
        if (that.next === null) {
          that.finished = true
        }
      }
    },
    invitationDetail (invitationId) {
      this.$router.push({
        name: 'InvitationDetail',
        params: {
          invitationId: invitationId
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
